import { HorizontalResizeContainer } from "@/components/ui/resize-container";
import { CloseIcon, FaroIconButton, FaroText, grey } from "@faro-lotv/flat-ui";
import { Box, Stack } from "@mui/system";
import { memo, type JSX } from "react";
import { CaptureTreeRegistrationReportView } from "./capture-tree-registration-report/CaptureTreeRegistrationReportView";
import { useRegistrationReportContext } from "./report-context";

/** @returns a right sidebar containing a registration report */
export const DataPreparationReportSidebar = memo(
  function DataPreparationReportSidebar(): JSX.Element {
    const { isReportOpen, setIsReportOpen } = useRegistrationReportContext();
    return (
      <>
        {/* Quality report */}
        {isReportOpen && (
          <Box
            component="div"
            sx={{
              width: 0,
              height: "100%",
              position: "relative",
            }}
          >
            <HorizontalResizeContainer
              initialWidth={600}
              minWidth={350}
              maxWidth={600}
              handleSide="left"
              sx={{
                position: "absolute",
                right: 0,
                height: "100%",
              }}
            >
              <Stack
                sx={{
                  p: 1,
                  overflowX: "auto",
                  width: "100%",
                  height: "100%",
                  backgroundColor: grey[0],
                  gap: 1,
                }}
              >
                <Stack
                  direction="row"
                  sx={{ justifyContent: "space-between", alignItems: "center" }}
                >
                  <FaroText
                    aria-label="detailed registration quality report"
                    variant="heading16"
                  >
                    Quality Report
                  </FaroText>
                  <FaroIconButton
                    aria-label="close detailed registration quality report"
                    onClick={() => setIsReportOpen(false)}
                  >
                    <CloseIcon />
                  </FaroIconButton>
                </Stack>
                <CaptureTreeRegistrationReportView />
              </Stack>
            </HorizontalResizeContainer>
          </Box>
        )}
      </>
    );
  },
);
